import { useRef, useState } from "react";
import { uploadFile } from "../utils/api";

export default function useUploadManager({ onUploadSuccess, onUploadError } = {}) {
  const pendingFilesRef = useRef({});
  const [uploadedFileName, setUploadedFileName] = useState({});

  const storeFile = (fieldName, file) => {
    pendingFilesRef.current[fieldName] = file || null;
  };

  const getFile = (fieldName) => {
    return pendingFilesRef.current[fieldName] || null;
  };

  const clearFile = (fieldName) => {
    pendingFilesRef.current[fieldName] = null;
  };

  const hasPendingFile = (fieldName) => {
    return !!pendingFilesRef.current[fieldName];
  };

  const uploadOne = async (fieldName) => {
    const token = sessionStorage.getItem("token");
    const file = pendingFilesRef.current[fieldName];

    if (!token || !file) return null;

    try {
      const result = await uploadFile({ file });

      setUploadedFileName((prev) => ({
        ...prev,
        [fieldName]: result?.filename || file.name,
      }));

      pendingFilesRef.current[fieldName] = null;

      if (onUploadSuccess) {
        await onUploadSuccess(fieldName, result?.filename || file.name);
      }

      return result;
    } catch (error) {
      if (onUploadError) {
        onUploadError(fieldName, error);
      }
      throw error;
    }
  };

  const uploadPendingFiles = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) return;

    const entries = Object.entries(pendingFilesRef.current);

    for (const [fieldName, file] of entries) {
      if (!file) continue;
      await uploadOne(fieldName);
    }
  };

  const handleSelectedFile = async (fieldName, file) => {
    storeFile(fieldName, file);

    if (sessionStorage.getItem("token") && file) {
      await uploadOne(fieldName);
    }
  };

  return {
    uploadedFileName,
    storeFile,
    getFile,
    clearFile,
    hasPendingFile,
    uploadOne,
    uploadPendingFiles,
    handleSelectedFile,
  };
}